import { Collapse, Divider } from '@ksyos/design-system';
import type { ICustomControlSupervisionReadProps } from '../../interfaces';
import { GradingSummary } from '../../../../../../common/enums/gradingSummary';
import { getDisplayName } from '../../../../../../common/utils/getDisplayName';
import { translateKey } from '../../../../../translate';
import { SupervisionReadButtons } from '../../../../elements/carePathButtons/SupervisionReadButtons';
import { ProcessItemFooter } from '../../../episodes/ProcessItemFooter';
import { ProcessItemHeader } from '../../../episodes/ProcessItemHeader';
import { SupervisionMode } from '../../../supervisions/SupervisionItem';
import { FormGroupRead } from '../../utils/v1/FormGroupRead';
import { TcohV2DiagnosticReportReadCustomControlFields } from './TcohV2DiagnosticReportReadCustomControlFields';
import { TcohV2SupervisionBiometricsSummary } from './TcohV2SupervisionBiometricsSummary';
import { TcohV2SupervisionGradingSummary } from './TcohV2SupervisionGradingSummary';

export function TcohV2SupervisionRead(props: ICustomControlSupervisionReadProps) {
    if (props.mode === SupervisionMode.showBiometrics) {
        return (
            <>
                <ProcessItemHeader
                    date={props.supervision.sentDateTime}
                    isFirstItem={props.isFirstItem}
                    isItemOpen={props.itemState.isOpen}
                    onToggle={async (isOpened) => await props.updateItemState({ ...props.itemState, isOpen: isOpened })}
                    organizationName={props.supervision.performerOrganization?.name}
                    practitionerName={
                        props.supervision.performerPractitioner
                            ? getDisplayName(props.supervision.performerPractitioner)
                            : undefined
                    }
                    process={props.process}
                    title={translateKey('supervision.supervision') + translateKey('supervision.biometrics')}
                />

                <TcohV2SupervisionBiometricsSummary {...props} />

                <Collapse isOpen={props.itemState.isOpen}>
                    {props.supervision.remarkBiometrics && (
                        <>
                            <Divider />

                            <FormGroupRead
                                label={translateKey('supervision.remarkBiometrics')}
                                value={props.supervision.remarkBiometrics}
                            />
                        </>
                    )}
                </Collapse>

                {props.supervision.remarkBiometrics && (
                    <ProcessItemFooter
                        isItemOpen={props.itemState.isOpen}
                        labelLess={translateKey('supervision.hideSupervision')}
                        labelMore={translateKey('supervision.showSupervision')}
                        onToggle={async (isOpened) =>
                            await props.updateItemState({ ...props.itemState, isOpen: isOpened })
                        }
                    />
                )}
                <SupervisionReadButtons {...props} />
            </>
        );
    } else if (props.mode === SupervisionMode.showGrading) {
        return (
            <>
                <ProcessItemHeader
                    date={props.supervision.sentDateTime}
                    isFirstItem={props.isFirstItem}
                    isItemOpen={props.itemState.isOpen}
                    onToggle={async (isOpened) => await props.updateItemState({ ...props.itemState, isOpen: isOpened })}
                    organizationName={props.supervision.performerOrganization?.name}
                    practitionerName={
                        props.supervision.performerPractitioner
                            ? getDisplayName(props.supervision.performerPractitioner)
                            : undefined
                    }
                    process={props.process}
                    status={
                        props.supervision.gradingSummary === GradingSummary.deviant
                            ? translateKey('diagnosis.deviant')
                            : undefined
                    }
                    title={translateKey('supervision.supervision') + translateKey('supervision.grading')}
                />

                <TcohV2SupervisionGradingSummary {...props} />

                <Collapse isOpen={props.itemState.isGradingOpen!}>
                    <Divider />
                    <TcohV2DiagnosticReportReadCustomControlFields
                        customControlData={props.supervision.customControlData}
                        isSupervising
                        txcsProcesId={props.process.txcsProcesId}
                    />

                    {props.supervision.remarkGrading && (
                        <>
                            <FormGroupRead
                                label={translateKey('supervision.remarkGrading')}
                                value={props.supervision.remarkGrading}
                            />
                        </>
                    )}
                </Collapse>

                <ProcessItemFooter
                    isItemOpen={props.itemState.isGradingOpen!}
                    labelLess={translateKey('supervision.hideSupervision')}
                    labelMore={translateKey('supervision.showSupervision')}
                    onToggle={async (isOpened) =>
                        await props.updateItemState({ ...props.itemState, isGradingOpen: isOpened })
                    }
                />
                <SupervisionReadButtons {...props} />
            </>
        );
    }

    return null;
}
